
import {verifyCardService} from '../services/components/verify_card.jsx'

function getState(activationcardState) {
    return {
        type: "ACTIVATIONCARD_STATE",
        activationcardState
    }
}

export const getactivationcardAction = (state) =>dispatch=>{

    let activationcardState = state
    verifyCardService((data, msg) => {
        if (msg === "success") {
            activationcardState = {
                message: "Success",
                status: 200,
                body: data
            }
        }
        else if (msg === "emptyBody") {
            
            activationcardState = {
                message: "Empty Body",
                status: 204,
                body: data
            }
        }
        else if(msg === "sessionout"){
            state={
                message: "sessionout",
                status: 401,
                body: data 
            }
        }
    dispatch(getState(activationcardState))
},state)
}


// WEBPACK FOOTER //
// ./src/actions/getcardactivation.jsx